import getMessagesForNamespaces from "@lib/i18n/getMessagesForNamespaces";
import CanonicalUrl from "@components/layout/CanonicalUrl";
import GiftCardMenuView from "@components/views/GiftCards/GiftCardMenu";

const GiftCardMenu = () => (
  <>
    <CanonicalUrl />
    <GiftCardMenuView />
  </>
);

export async function getServerSideProps({ params: { locale } }) {
  return {
    props: {
      ...(await getMessagesForNamespaces(locale, ["common", "gift_cards"])),
    },
  };
}

GiftCardMenu.requireAuth = false;

export default GiftCardMenu;
